export default {
  getEvents() {
    return {
      "node:click": "onClick",
    };
  },
  shouldBegin(ev) {
    const { target, item } = ev;
    const targetName = target.get("name") || "";
    if (
      targetName.startsWith("button:") &&
      !this.graph._addingEdge &&
      !this.graph._addingEdgeByClick
    ) {
      return true;
    }

    return false;
  },

  onClick(ev) {
    if (this.shouldBegin(ev)) {
      this.graph.emit("xNode:buttonClick", ev);
    }
  },
};
